<t4-header icon="glyphicon-stats" title="{{'TO.DataExport.Headline' |translate : 'Data export' }}"></t4-header>

<mat-tab-group>
    <mat-tab label="{{ 'TO.DataExport.tabContractEvents' | translate:'Rental contract events'}}">
        <t4-periodPicker period="month" [(from)]="from" [(to)]="to" (periodChanged)="updateParams()"></t4-periodPicker>
        <t4-container>
            <t4-data-table apiMethod="TurboOrder/GetContractEvents" [parameters]="queryParameters" reportName="DeliveryReportPerOwner" databaseName="TurboOrder" headline="{{ 'TO.DataExport.tabContractEvents' | translate:'Rental contract events'}}" matSort >
                <ng-container matColumnDef="Date">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Reports.DailySales.Table_date' |translate : 'Date' }}</mat-header-cell>
                    <mat-cell *matCellDef="let row">{{ row.Date | date : 'yyyy-MM-dd' }}</mat-cell>
                    <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
                </ng-container>
            </t4-data-table>
        </t4-container>
    </mat-tab>

    <mat-tab label="{{ 'TO.DataExport.tabLocationStatistics' | translate:'Location statistics'}}">
        <t4-container>
            <t4-data-table apiMethod="TurboOrder/GetLocationStatistics" headline="{{ 'TO.Widget.LocationStats.Headline' | translate : 'Location statistics (Last 12 months)' }}" matSort [filterFields]="['Group','Location','LocationCode','RegNo','Year','OwnerId']"></t4-data-table>
        </t4-container>
    </mat-tab>
</mat-tab-group>
